// extracted by mini-css-extract-plugin
export var container = "about-module--container--GpJlX";
export var heading = "about-module--heading--IN-sS";
export var acmImage = "about-module--acmImage--XKAJZ";
export var benefits = "about-module--benefits--7AaZB";